var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"orbs_background"},_vm._l((_vm.bubbles),function(bubble){return _c('div',{key:bubble.index,class:bubble.class,style:(bubble.style)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }